// extracted by mini-css-extract-plugin
export default {"Attachment":"styles_Attachment__bqUHO","links":"styles_links__JXnHb"};